import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/styles';
import { Spinner } from 'components/elements';
import config from 'config';
import StripeContext from 'contexts/stripeContext';

export default function StripeProvider({ children }) {
  const theme = useTheme();
  const [settings, setSettings] = useState({
    clientSecret: null,
    intentId: null,
    accountId: null,
    isEnabled: false,
  });

  const [stripePromise, setStripePromise] = useState(null);
  const { i18n } = useTranslation();

  const { clientSecret, intentId, accountId, isEnabled } = settings;

  useEffect(() => {
    if (isEnabled) {
      if (accountId) {
        const res = loadStripe(config.stripeApiKey, {
          stripeAccount: accountId,
        });
        setStripePromise(res);
      } else {
        const res = loadStripe(config.stripeApiKey);
        setStripePromise(res);
      }
    }
  }, [accountId, isEnabled]);

  const hasClientSecret = clientSecret?.length > 0;
  const appearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: theme.palette.primary.main,
    },
    rules: {
      '.Input::placeholder': {
        color: `${theme.palette.font.main}70`,
      },
    },
  };
  const options = { clientSecret, appearance, locale: i18n.language };
  let value;
  if (hasClientSecret) {
    value = { ...settings, isEnabled, setSettings };
  } else {
    value = { clientSecret, intentId, isEnabled, setSettings };
  }

  if (hasClientSecret) {
    return (
      <StripeContext.Provider value={value}>
        <Elements options={options} stripe={stripePromise}>
          {children}
        </Elements>
      </StripeContext.Provider>
    );
  }
  return (
    <StripeContext.Provider value={value}>
      {isEnabled ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Spinner />
        </Box>
      ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{children}</>
      )}
    </StripeContext.Provider>
  );
}

StripeProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
};
